import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormHtml = () => (
  <ComponentDocs name="<FormHtml/>" entry="FormHtml" propsEntry="FormHtmlProps">
    <ComponentExample
      name="HTML editor"
      import={import("examples/Forms/FormHtml/HtmlEditorExample")}
      rawImport={import("examples/Forms/FormHtml/HtmlEditorExample?raw")}
    />
    <ComponentExample
      name="Custom toolbar"
      import={import("examples/Forms/FormHtml/CustomToolbarExample")}
      rawImport={import("examples/Forms/FormHtml/CustomToolbarExample?raw")}
    />
    <ComponentExample
      name="External image upload"
      description="The onImageUpload prop can be used to upload an image to a backend endpoint. It should return a URL for the uploaded image, and an optional blobId value."
      import={import("examples/Forms/FormHtml/ExternalImageUploadExample")}
      rawImport={import(
        "examples/Forms/FormHtml/ExternalImageUploadExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormHtml;
